import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function WhoItsFor() {
  const checklist = ['You already take supplements but are not sure if you’re doing it right', 'You want better results without buying more and more products', 'You feel overwhelmed by conflicting information online', 'You want a simple reference guide you can use anytime', 'You care about choosing cleaner, higher-quality supplement brands', 'You want to stop wasting money on products your body may not even absorb well'];
  return <Section className="bg-white rounded-3xl shadow-sm border border-sage-light/30 my-12" data-id="element-237">
      <div className="max-w-3xl mx-auto" data-id="element-238">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-primary-dark" data-id="element-239">
          This Guide Is Perfect For You If…
        </h2>

        <div className="space-y-4" data-id="element-240">
          {checklist.map((item, i) => <div key={i} className="flex items-start gap-4 p-4 hover:bg-cream-dark/20 rounded-xl transition-colors" data-id="element-241">
              <div className="mt-1 bg-primary text-white rounded-full p-1 shrink-0" data-id="element-242">
                <Check size={16} strokeWidth={3} data-id="element-243" />
              </div>
              <p className="text-lg text-charcoal/90 font-medium leading-relaxed" data-id="element-244">
                {item}
              </p>
            </div>)}
        </div>
      </div>
    </Section>;
}